module.exports = __webpack_public_path__ + "static/img/4.a5e2e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/five/4.png
// module id = j8HU
// module chunks = 1